'use client';

import * as React from 'react';
import { useSchedulerStoreContext } from "../../use-scheduler-store-context/index.mjs";
import { schedulerEventSelectors } from "../../scheduler-selectors/index.mjs";

/**
 * Returns the drag preview to render when the dragged event is not over a valid drop target.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function useDragPreview(parameters) {
  const {
    renderDragPreview,
    showPreviewOnDragStart,
    data,
    type
  } = parameters;
  const store = useSchedulerStoreContext(true);
  const [state, setState] = React.useState({
    isDragging: false,
    dragPosition: null
  });
  const element = React.useMemo(() => {
    if (state.dragPosition == null) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      style: {
        position: 'fixed',
        top: state.dragPosition.clientY,
        left: state.dragPosition.clientX,
        pointerEvents: 'none',
        zIndex: 9999
      },
      children: renderDragPreview({
        data,
        type
      })
    });
  }, [state.dragPosition, renderDragPreview, data, type]);
  const actions = React.useMemo(() => ({
    onDragStart: location => {
      setState({
        isDragging: true,
        dragPosition: showPreviewOnDragStart ? location.current.input : null
      });
    },
    onDrag: location => {
      let shouldShowPreview = true;
      if (store && type === 'internal-event' && !schedulerEventSelectors.canDropEventsToTheOutside(store.state)) {
        shouldShowPreview = false;
      } else if (location.current.dropTargets.some(el => el.data.isSchedulerDropTarget)) {
        shouldShowPreview = false;
      }
      setState({
        isDragging: true,
        dragPosition: shouldShowPreview ? location.current.input : null
      });
    },
    onDrop: () => {
      setState({
        isDragging: false,
        dragPosition: null
      });
    }
  }), [store, showPreviewOnDragStart, type]);
  return {
    element,
    state,
    actions
  };
}